module.exports = {"id":"192371","name":"Fabián Rinaudo","rating":"72","photo":"./data/images/photos/0/192371.png","club":{"name":"G. La Plata","logo":"./data/images/clubs/G.LaPlata.png"},"positions":["MDC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FabianRinaudo0.json
// module id = 1333
// module chunks = 0